import React from 'react';

/**
 * Apply For Me promo artwork (folder + paper plane + sparkles), inlined as an SVG
 * component so it renders on both the SSR server and the client.
 *
 * It must be inlined rather than imported as a file asset: the client bundle is
 * built with Webpack (asset/resource), but the server runs via `tsc`/`tsx`, which
 * has no asset loader and would try to parse the file as JavaScript.
 *
 * Extracted from the Figma promo frame with a transparent background, so the
 * surrounding header gradient shows through behind it.
 */
const ApplyForMePromoSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width="160"
        height="112"
        viewBox="0 0 160 112"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g>
            <path
                d="M91.1519 75.4266C91.9926 72.0599 92.4388 68.537 92.4388 64.9098C92.4388 41.0164 73.0735 21.647 49.1852 21.647C25.2969 21.647 5.93164 41.0164 5.93164 64.9098C5.93164 73.8463 8.64056 82.1499 13.2819 89.0439C0.563147 96.2362 0 112 0 112H159.869C162.341 89.5735 129.353 66.5876 102.285 71.7747C97.7658 72.6407 94.1789 73.9284 91.1519 75.4266Z"
                fill="white"
            />
            <path
                d="M91.1519 75.4266C91.9926 72.0599 92.4388 68.537 92.4388 64.9098C92.4388 41.0164 73.0735 21.647 49.1852 21.647C25.2969 21.647 5.93164 41.0164 5.93164 64.9098C5.93164 73.8463 8.64056 82.1499 13.2819 89.0439C0.563147 96.2362 0 112 0 112H159.869C162.341 89.5735 129.353 66.5876 102.285 71.7747C97.7658 72.6407 94.1789 73.9284 91.1519 75.4266Z"
                fill="url(#afmPaint1)"
                fillOpacity={0.4}
            />
            <g>
                <g>
                    <g filter="url(#afmFilter1)">
                        <path
                            d="M74.4344 58.4445L71.4028 54.3816H52.3177L49.2862 58.4445H42.6719V111.194H129.898V58.4445H74.4344Z"
                            fill="url(#afmPaint2)"
                        />
                    </g>
                    <g filter="url(#afmFilter2)">
                        <path
                            d="M71.6175 53.1619L71.6172 53.1605L71.6192 53.1618L139.565 14.5484L139.4 14.7166L82.6414 61.9322L88.0248 67.098L79.3621 75.9304L71.6175 53.1619Z"
                            fill="#DBE2FD"
                        />
                    </g>
                    <g filter="url(#afmFilter3)">
                        <path
                            d="M82.2728 61.6012L82.2063 61.5647L78.8008 75.931L87.9477 66.9279L82.2728 61.6012Z"
                            fill="#131D64"
                        />
                    </g>
                    <path
                        d="M50.707 40.2244L71.371 53.0749L139.563 14.5471L50.707 40.2244Z"
                        fill="white"
                    />
                    <g>
                        <g filter="url(#afmFilter4)">
                            <path
                                d="M130.007 111.039H42.7812L33.0664 69.6526H119.466L130.007 111.039Z"
                                fill="url(#afmPaint3)"
                            />
                        </g>
                        <g filter="url(#afmFilter5)">
                            <path
                                d="M80.5111 90.039L87.1716 88.5742L70.2429 107.337L73.8506 91.5038L67.0977 92.9686L84.1189 74.2751L80.5111 90.039Z"
                                fill="white"
                            />
                        </g>
                    </g>
                    <path
                        d="M139.282 14.8658L101.485 80.1472L82.319 61.8943L139.282 14.8658Z"
                        fill="url(#afmPaint4)"
                    />
                </g>
            </g>
            <g filter="url(#afmFilter6)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M77.0938 1.25132C76.9228 1.22856 76.9114 1.31384 76.8031 1.473C75.3895 6.8393 72.2495 10.1533 66.4256 10.7668C66.3401 10.7554 66.2432 10.8293 66.2318 10.9146C66.3059 11.0112 66.2945 11.0965 66.4655 11.1193C72.2094 12.4044 75.0356 15.9917 75.7817 21.4719C75.7703 21.5571 75.8444 21.6538 76.0153 21.6765C76.1008 21.6879 76.1977 21.614 76.2205 21.4435C77.6341 16.0772 80.7742 12.7632 86.598 12.1496C86.6835 12.161 86.7804 12.0871 86.7918 12.0019C86.7177 11.9052 86.7291 11.8199 86.5581 11.7972C80.8142 10.512 77.988 6.92475 77.2419 1.44461C77.3388 1.37071 77.2647 1.27407 77.0938 1.25132Z"
                    fill="#E867A8"
                />
            </g>
            <g filter="url(#afmFilter7)">
                <path
                    d="M34.4731 35.1364C34.4484 35.0597 34.5144 34.9971 34.5927 34.9729C34.671 34.9487 34.7349 35.0133 34.7596 35.09C35.9871 38.6324 38.3567 40.6411 42.3549 40.755C42.4455 40.7692 42.4971 40.7954 42.5218 40.8721C42.495 40.9225 42.4681 40.973 42.3898 40.9972C38.5521 42.1831 36.8348 44.7378 36.6175 48.4736C36.6422 48.5503 36.5763 48.6128 36.4979 48.637C36.4196 48.6612 36.3558 48.5967 36.3311 48.52C35.1036 44.9776 32.734 42.9689 28.7358 42.855C28.6451 42.8409 28.5936 42.8146 28.5689 42.7379C28.5957 42.6875 28.6225 42.637 28.7008 42.6128C32.5385 41.4269 34.2559 38.8722 34.4731 35.1364Z"
                    fill="white"
                />
                <path
                    d="M31.6092 55.8527C31.6164 55.8114 31.6622 55.7978 31.7044 55.8049C31.7466 55.812 31.7605 55.8568 31.7533 55.8981C31.4592 57.8266 32.0681 59.3111 33.8932 60.298C33.9318 60.3257 33.9493 60.3499 33.9421 60.3912C33.9174 60.4084 33.8926 60.4255 33.8504 60.4184C31.783 60.0714 30.3647 60.8542 29.354 62.5348C29.3468 62.5761 29.3009 62.5896 29.2588 62.5826C29.2166 62.5755 29.2027 62.5306 29.2099 62.4893C29.504 60.5609 28.8951 59.0763 27.07 58.0895C27.0314 58.0617 27.0139 58.0375 27.0211 57.9962C27.0458 57.9791 27.0706 57.9619 27.1128 57.969C29.1802 58.316 30.5985 57.5333 31.6092 55.8527Z"
                    fill="white"
                />
            </g>
        </g>
        <defs>
            <filter
                id="afmFilter1"
                x="42.6719"
                y="54.3816"
                width="87.7266"
                height="57.3123"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.5" dy="0.5" />
                <feGaussianBlur stdDeviation="0.25" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
            </filter>
            <filter
                id="afmFilter2"
                x="71.6172"
                y="14.5483"
                width="67.9492"
                height="63.3821"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.176471 0 0 0 0 0.176471 0 0 0 0 0.176471 0 0 0 0.04 0"
                />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.176471 0 0 0 0 0.176471 0 0 0 0 0.176471 0 0 0 0.08 0"
                />
                <feBlend mode="normal" in2="effect1_innerShadow" result="effect2_innerShadow" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.176471 0 0 0 0 0.176471 0 0 0 0 0.176471 0 0 0 0.16 0"
                />
                <feBlend mode="normal" in2="effect2_innerShadow" result="effect3_innerShadow" />
            </filter>
            <filter
                id="afmFilter3"
                x="78.8008"
                y="61.5647"
                width="10.1484"
                height="15.3662"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.5" dy="0.5" />
                <feGaussianBlur stdDeviation="0.25" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.5" dy="0.5" />
                <feGaussianBlur stdDeviation="0.25" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                <feBlend mode="normal" in2="shape" result="effect2_innerShadow" />
            </filter>
            <filter
                id="afmFilter4"
                x="33.0664"
                y="69.6526"
                width="97.9414"
                height="42.3867"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.5" dy="0.5" />
                <feGaussianBlur stdDeviation="0.25" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            </filter>
            <filter
                id="afmFilter5"
                x="67.0977"
                y="74.2751"
                width="20.5742"
                height="33.5623"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.5" dy="0.5" />
                <feGaussianBlur stdDeviation="0.25" />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
            </filter>
            <filter
                id="afmFilter6"
                x="66.2305"
                y="1.2478"
                width="21.5625"
                height="21.4299"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.5" dy="0.5" />
                <feGaussianBlur stdDeviation="0.25" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            </filter>
            <filter
                id="afmFilter7"
                x="27.0195"
                y="34.9678"
                width="16.5039"
                height="28.6167"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.5" dy="0.5" />
                <feGaussianBlur stdDeviation="0.25" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
            </filter>
            <linearGradient
                id="afmPaint1"
                x1="-1.26609e-06"
                y1="173.311"
                x2="85.0048"
                y2="86.7716"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FEF8F4" />
                <stop offset="1" stopColor="#C74289" />
            </linearGradient>
            <linearGradient
                id="afmPaint2"
                x1="86.2801"
                y1="111.209"
                x2="86.2801"
                y2="54.4372"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#C08A38" />
                <stop offset="1" stopColor="#F5CB9D" />
            </linearGradient>
            <linearGradient
                id="afmPaint3"
                x1="81.5403"
                y1="111.054"
                x2="81.5403"
                y2="69.668"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E0A961" />
                <stop offset="1" stopColor="#F5CB9D" />
            </linearGradient>
            <linearGradient
                id="afmPaint4"
                x1="127.258"
                y1="15.4714"
                x2="117.058"
                y2="82.6801"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#0066FF" />
                <stop offset="1" stopColor="#004FCB" />
            </linearGradient>
        </defs>
    </svg>
);

export default ApplyForMePromoSvg;
